import { Injectable } from '@angular/core';
import { UUID } from '@macs-frontend/core/utils/uuid';

interface ExactSyncTimeRecord {
  id: string;
  lastSync: number;
}

type ExactSyncTimeData = Record<string, ExactSyncTimeRecord>;

const LOCAL_STORAGE_KEY = 'EXACT_SYNC_TIME_DATA';
const LIFE_TIME = 5 * 60 * 1000;

@Injectable({
  providedIn: 'root',
})
export class ExactSyncTimeService {
  private getData() {
    const localStorageString = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (!localStorageString) {
      return {} as ExactSyncTimeData;
    }

    return JSON.parse(localStorageString) as ExactSyncTimeData;
  }

  needsSync(id: string | UUID): boolean {
    const lastSync = this.getData()[id.toString()]?.lastSync;
    if (!lastSync) {
      return true;
    }

    return Date.now() > lastSync + LIFE_TIME;
  }

  markAsSynced(id: string | UUID) {
    const data: ExactSyncTimeData = {
      ...this.getData(),
      [id.toString()]: {
        id: id.toString(),
        lastSync: Date.now(),
      },
    };

    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(this.removeOldRecords(data)));
  }

  removeOldRecords(data: ExactSyncTimeData): ExactSyncTimeData {
    return Object.fromEntries(
      Object.entries(data).filter(([key, value]) => {
        return value.lastSync > Date.now() - LIFE_TIME;
      }),
    );
  }
}
